// extracted by mini-css-extract-plugin
export default {"row":"TableRow_row__pA3wx","labelCell":"TableRow_labelCell__GTgms","title":"TableRow_title__+G3UZ","dataCell":"TableRow_dataCell__xwkA5","content":"TableRow_content__0ktQv"};